import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import type { IExceptionTelemetry } from "@microsoft/applicationinsights-web";
import { useCallback } from "react";

export function useTrackException() {
  const appInsights = useAppInsightsContext();
  const trackException = useCallback(
    (telemetry: IExceptionTelemetry) => {
      appInsights.trackException(telemetry);
    },
    [appInsights]
  );
  return trackException;
}
